import React, { useEffect, useState, useMemo } from 'react';
import './index.scss';
import ReportCard from './reportCard';
import { getReportData } from 'redux/report/action';
import { useDispatch, useSelector } from 'react-redux';
import LoadingAnimation from 'components/common/LoadingAnimation';
const Report = () => {
  const { data, loading } = useSelector(state => state.orderReports);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const [tempFilters, setTempFilters] = useState(null);
  const [filters, setFilters] = useState(null);
  const handleInputChange = event => {
    const { name, value } = event.target;
    setTempFilters(prevFilters => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  const handleClearFilter = () => {
    setFilters({
      startDate: '',
      endDate: '',
      company: '',
    });
    setTempFilters({
      startDate: '',
      endDate: '',
      company: '',
    });
    setCurrentPage(1);
  };
  const fetchData = () => {
    dispatch(
      getReportData(
        filters
          ? {
              page: currentPage,
              ...Object.fromEntries(
                Object.entries(filters).filter(([_, value]) => value !== ''),
              ),
            }
          : { page: currentPage },
      ),
    );
  };
  const handleButtonClick = () => {
    const { startDate, endDate, company } = tempFilters || {};
    if ((!startDate || !endDate) && !company) {
      console.warn(
        'Either both startDate and endDate must be present, or company must be provided.',
      );
      return;
    }
    if (JSON.stringify(tempFilters) == JSON.stringify(filters)) {
      fetchData();
    } else if (JSON.stringify(tempFilters) !== JSON.stringify(filters)) {
      setCurrentPage(1);
    }
    setFilters(tempFilters);
  };
  useEffect(() => {
    fetchData();
  }, [currentPage, filters]);

  const Loader = useMemo(() => {
    if (loading) {
      return <LoadingAnimation />;
    }
    return null;
  }, [loading]);

  return (
    <>
      {Loader}
      <div className="report-container">
        <h2 className="report-title">Report Overview</h2>
        <div className="report-card">
          <div className="filters">
            <div className="filter-group">
              <label>Delivery Start Date</label>
              <input
                type="date"
                name="startDate"
                placeholder="Select Start Date"
                style={{ cursor: 'pointer' }}
                value={tempFilters?.startDate}
                onChange={handleInputChange}
                onClick={e => e.target.showPicker && e.target.showPicker()}
              />
            </div>
            <div className="filter-group">
              <label>Delivery End Date</label>

              <input
                type="date"
                name="endDate"
                placeholder="Select End Date"
                style={{ cursor: 'pointer' }}
                value={tempFilters?.endDate}
                onChange={handleInputChange}
                onClick={e => e.target.showPicker && e.target.showPicker()}
              />
            </div>
            <div className="filter-group">
              <label>Search by Vendor Name</label>
              <input
                type="text"
                name="company"
                placeholder="Enter Vendor Name"
                value={tempFilters?.company}
                onChange={handleInputChange}
              />
            </div>

            {/* Styled button inside filters div */}
            <button className="submit-button" onClick={handleButtonClick}>
              Submit
            </button>
            <button className="remove-filter" onClick={handleClearFilter}>
              Clear
            </button>
          </div>
          {loading ? (
            <div className="report-text">Fetching reports…</div>
          ) : data?.userCateringOrders?.length > 0 ? (
            <ReportCard
              data={data}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
            />
          ) : (
            <div className="report-text">No results available</div>
          )}
        </div>
      </div>
    </>
  );
};

export default Report;
